/**
 * Pulses a ring and a tinted background on a field that got focused from the preview, the focus alone is too subtle
 * in the property panel. inset keeps the ring inside elements in scroll areas that would clip it
 */
export function flashFocus(element: Element, options: {inset?: boolean} = {}): void {
  const rgb = getComputedStyle(document.body).getPropertyValue('--mm-accent-rgb').trim();
  if (!element || !rgb || typeof element.animate !== 'function') {
    return;
  }
  const from: Keyframe = {boxShadow: options.inset ? `inset 0 0 0 3px rgba(${rgb}, .9)` : `0 0 0 0 rgba(${rgb}, .65)`};
  const to: Keyframe = {boxShadow: options.inset ? `inset 0 0 0 3px rgba(${rgb}, 0)` : `0 0 0 7px rgba(${rgb}, 0)`};
  from.backgroundColor = `rgba(${rgb}, .2)`;
  to.backgroundColor = getComputedStyle(element).backgroundColor;
  element.animate([from, to], {duration: 900, iterations: 2, easing: 'ease-out'});
}
